import icblast, {
  InternetIdentity,
  AnonymousIdentity,
} from '@infu/icblast/src/browser.js';

// const qgig_can = 'q4eej-kyaaa-aaaaa-aaaha-cai';
const qgig_can = 'ya2w2-qyaaa-aaaam-abj5q-cai';

// anon
// const ic = icblast({ local: true, local_host: 'http://localhost:8080' });
const ic = icblast({});

InternetIdentity.create();

export const isLogged = () =>
  InternetIdentity.isAuthenticated() &&
  InternetIdentity.getPrincipal().toText() !== '2vxsx-fae';

// authenticated
export const login = async () => {
  if (
    !InternetIdentity.isAuthenticated() ||
    InternetIdentity.getPrincipal().toText() === '2vxsx-fae'
  ) {
    console.log('not authenticated');
    await InternetIdentity.login({
      //   identityProvider:
      //     'http://localhost:8080?canisterId=qhbym-qaaaa-aaaaa-aaafq-cai',
    });
  } else {
    console.log('authenticated', InternetIdentity.getPrincipal().toText());
  }
  await delay(1000);
  let identity = InternetIdentity.getIdentity();

  const icu = icblast({
    // local: true,
    // local_host: 'http://localhost:8080',
    identity,
  });

  cans['qgig'] = await icu(qgig_can);
  cans['qgig'].$logged = true;
  await delay(1000);
};

const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

export const logout = () => InternetIdentity.logout();

export const cans = {
  // add as many as you want
  qgig: ic(qgig_can),
};

export const waitCanisters = async () => {
  // todo: use Promise.all
  for (let k in cans) {
    cans[k] = await cans[k];
  }
};

export { InternetIdentity };

export default ic;
